import React,{useState,useEffect} from "react";
import api from "../../../api/api";
import {useAcademicYear} from "../../../AcademicYearContext";

import TableStyle from "./TableStyle";

import {
Table,
Input,
Button,
Card,
Typography,
Space,
Empty,
Tag,
message,
Popconfirm
} from "antd";

import {
SearchOutlined,
SafetyOutlined
} from "@ant-design/icons";
import Secure from "./Secure";
import EditStudentAdmissionPopup from "./EditStudentAdmissionPopup";
import AdmissionStuListByClass from "./AdmissionStuListByClass";
import AdmissionDataFormDownload from "./AdmissionDataFormDownload";

const {Title}=Typography;


// ================= CUSTOM LOADER =================



const PageLoader=()=>{

return(

<div
style={{
display:"flex",
justifyContent:"center",
alignItems:"center",
height:120,
gap:8
}}
>

{[1,2,3].map((item,index)=>(

<span
key={item}
style={{
width:12,
height:12,
background:index===1?"#eea507":"#311701",
borderRadius:"50%",
animation:"bounce 1.4s infinite ease-in-out",
animationDelay:`${index*0.2}s`
}}
/>

))}

</div>

);

};





const StudentsAdmission=()=>{
const [secureStudent,setSecureStudent]=useState(null);
const {selectedYear}=useAcademicYear();
const [students,setStudents]=useState([]);
const [filteredStudents,setFilteredStudents]=useState([]);
const [loading,setLoading]=useState(false);
const [searchTerm,setSearchTerm]=useState("");
const [editStudent,setEditStudent]=useState(null);

const [darkMode,setDarkMode]=useState(
localStorage.getItem("darkMode")==="true"
);

const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
    total: 0,
});

// ================= TOKEN =================

const getToken=()=>{

return localStorage.getItem("access");

};




// ================= DARK MODE LISTENER =================

useEffect(()=>{

const observer=new MutationObserver(()=>{

setDarkMode(
document.body.classList.contains("dark-mode")
);

});


observer.observe(document.body,{
attributes:true,
attributeFilter:["class"]
});


return()=>observer.disconnect();


},[]);






// ================= FETCH =================

useEffect(()=>{

if(selectedYear){

fetchStudents();

}

},[selectedYear]);





const fetchStudents = async (page = 1, pageSize = 50) => {


const token=getToken();


if(!token){

window.location.href="/login";

return;

}



try{

setLoading(true);


const res = await api.get(
    `/api/users/students/?academic_year=${selectedYear.id}&page=${page}&page_size=${pageSize}`,
    {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }
);

setStudents(res.data.results || []);
setFilteredStudents(res.data.results || []);

setPagination({
    current: res.data.current_page,
    pageSize: res.data.page_size,
    total: res.data.count,
});


setStudents(res.data.results || []);
setFilteredStudents(res.data.results || []);



}catch(error){

console.log(error);


if(error.response?.status===401){

localStorage.removeItem("access");

window.location.href="/login";

}


}
finally{

setLoading(false);

}


};



const deleteStudent = async(student)=>{


try{


await api.delete(

`/api/users/students/${student.id}/`,

{

headers:{

Authorization:
`Bearer ${localStorage.getItem("access")}`

}

}

);



message.success(
"Student admission deleted successfully"
);



fetchStudents();



}catch(error){


console.log(error);


message.error(
"Unable to delete student"
);


}


};



// ================= SEARCH =================

useEffect(()=>{


const result=students.filter(student=>

(student.full_name||"")

.toLowerCase()

.includes(
searchTerm.toLowerCase()
)
);
setFilteredStudents(result);
},[searchTerm,students]);

// ================= TABLE =================

const columns=[

{

title:"No",

width:60,

fixed:"left",

render:(_,__,index)=>index+1

},


{

title:"Student Name",

dataIndex:"full_name",

render:text=>(

<strong>

{text}

</strong>

)

},


{

title:"Session",

dataIndex:"division_assigned_name",

responsive:["md"]

},


{

title:"Class",

dataIndex:"grade_class_name"

},


{

title:"Semester",

dataIndex:"semester_status",

responsive:["lg"]

},


{

title:"Status",

dataIndex:"status",

render:(status)=>(

<Tag

color={

status==="Active"

?

"green"

:

"red"

}

>

{status}

</Tag>

)

},

{
title:"Action",

fixed:"right",

width:260,


render:(_,student)=>(


<Space>


<Button

type="primary"

onClick={()=>setEditStudent(student)}

>

Edit

</Button>




<Popconfirm

title="Delete Student Admission"

description={
`Are you sure you want to delete ${student.full_name}?`
}

okText="Yes, Delete"

cancelText="Cancel"

okButtonProps={{
danger:true
}}

onConfirm={()=>deleteStudent(student)}

>


<Button

danger

type="primary"

>

Delete

</Button>


</Popconfirm>




<Button

className="secure-btn"

type="primary"

icon={<SafetyOutlined/>}

onClick={()=>{

setSecureStudent(student);

setTimeout(()=>{

setSecureStudent(null);

},1000);

}}

>

Authentication

</Button>



</Space>


)


}


];



return(

    

<div

style={{

padding:"20px",

minHeight:"100vh",

background:"transparent"

}}

>

<div>
    <TableStyle/>
</div>




<Card

bordered={false}

style={{

borderRadius:20,

background:darkMode
?
"#1f1f1f"
:
"rgba(255,255,255,.92)",

boxShadow:
darkMode
?
"0 8px 30px rgba(0,0,0,.5)"
:
"0 8px 25px rgba(0,0,0,.08)"

}}

>


{/* TITLE BAR */}

<div

style={{

background:

darkMode

?

"linear-gradient(135deg,#311701,#eea507)"

:

"linear-gradient(135deg,#311701,#eea507)",


padding:"18px",

borderRadius:"14px",

marginBottom:25

}}

>


<Title

level={3}

style={{

margin:0,

textAlign:"center",

color:"#fff"

}}

>
Student Admissions
(
{selectedYear?.name || "Select Year"}
)
</Title>
</div>


<div>
<div>
    <AdmissionStuListByClass />
</div>
</div>



{/* SEARCH */}

<Space

style={{

marginBottom:20,

width:"100%"

}}

>


<Input

size="large"

allowClear

prefix={<SearchOutlined/>}

placeholder="Search student name..."

value={searchTerm}

onChange={(e)=>setSearchTerm(e.target.value)}

style={{

maxWidth:400,

borderRadius:10

}}

/>

<AdmissionDataFormDownload />

</Space>

{

loading

?

<PageLoader/>

:

<Table

columns={columns}

dataSource={filteredStudents}

rowKey="id"

bordered

rowClassName={()=>"student-row"}


scroll={

window.innerWidth <= 768

?

{
x:900
}

:

undefined

}


pagination={{
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: pagination.total,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "50", "100"],
    showTotal: total => `Total ${total} students`,
    onChange: (page, pageSize) => {
        fetchStudents(page, pageSize);
    },
}}


locale={{

emptyText:

<Empty description="No students found"/>

}}


/>


}



</Card>

<div>{secureStudent && (
   <Secure student={secureStudent}/>)}
</div>
<div>
<EditStudentAdmissionPopup
visible={!!editStudent}
student={editStudent}
onClose={()=>setEditStudent(null)}
refresh={fetchStudents}
/>
</div>

</div>


);


};


export default StudentsAdmission;